import { createContext, Dispatch, SetStateAction } from 'react';
import { PageNameLidInformation } from '@pages/oneLid/components/information/InformationContainer';

import { RootState } from 'store/store';

interface IMethods {
  setInfoTab: Dispatch<SetStateAction<ILeadContext['infoTab']>>;
  setSetting: (value: RootState['crmV2Slice']['setting']) => void;
}

export interface ILeadContext extends IMethods {
  infoTab: PageNameLidInformation;
}

const Context = createContext<ILeadContext>({} as ILeadContext);

export default Context;
